import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/client';

export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async ({ email, newPassword }) => {
    setLoading(true);
    try {
      await api.post('/api/auth/change-password', { email, newPassword });
      message.success('Password updated. Please log in.');
      navigate('/');
    } catch (e) {
      message.error(e.response?.data?.error || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: '#fafafa',
    }}>
      <div style={{ width: 380 }}>
        <div style={{ marginBottom: 40, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.5px', color: '#0a0a0a' }}>
            SGLearner
          </div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>
            Singapore's PSLE, O-Level, JC & IB mastery platform
          </div>
        </div>

        <div style={{
          background: '#fff', border: '1px solid #e8e8e8',
          borderRadius: 10, padding: '32px 32px',
        }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: '#0a0a0a' }}>
            Reset password
          </h2>
          <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>
            Enter your email and a new password.
          </p>

          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email' }]}>
              <Input size="large" placeholder="you@email.com" />
            </Form.Item>
            <Form.Item
              label="New Password"
              name="newPassword"
              rules={[{ required: true, min: 6, message: 'At least 6 characters' }]}
            >
              <Input.Password size="large" placeholder="••••••••" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 12 }}>
              <Button
                type="primary" htmlType="submit" block size="large"
                loading={loading}
                style={{ background: '#0a0a0a', border: 'none', fontWeight: 500 }}
              >
                Reset password
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center', fontSize: 13, color: '#666' }}>
            <Link to="/" style={{ color: '#0a0a0a', fontWeight: 500 }}>Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
